import {
  useController,
  useFormContext,
} from 'react-hook-form'
import { ComGate } from 'shopify-payments-types'

import {
  Card,
  // Select,
  Link,
  TextContainer,
  SelectOption,
} from '@shopify/polaris'

// import { useAccount } from '../hooks/useAccount'
import { getTranslation } from '../util/getTranslation'

export function SettingsOrderNameType({ orderNameTypes }: { orderNameTypes: SelectOption[] }) {
  // const account = useAccount<ComGate.TSegmentAccount>()
  // const { setValue } = useFormContext()
  // const { field } = useController({
  //   name: 'orderNameType',
  //   defaultValue: account.segmentConfig.orderNameType || 'number',
  // })

  // const scopes = account.shopifyAccessScopes?.split(",") ?? [];
  // if(!scopes.includes('read_orders')) {
  //   return (
  //     <Card.Section>
  //       <TextContainer>
  //         <p>{getTranslation(
  //           'Synchronizace ID objednávky',
  //           'Order ID synchronization',
  //         )}</p>
  //         <p style={{ color: '#aa8414' }}>{getTranslation(
  //           'Čísla objednávek nejsou synchronizována.',
  //           'Order numbers are not synchronized.',
  //         )}</p>
  //         <p style={{ color: '#6d7175' }}>{getTranslation(
  //           'Není možné zvolit formát "Synchronizace ID objednávky", protože platební doplněk Comgate nemá přístup k informacím o názvech objednávek.',
  //           'It is not possible to select the \'Order ID synchronization\' format because the Comgate payment plugin does not have access to the order name information.',
  //         )}</p>
  //       </TextContainer>
  //       <p style={{ marginTop: '16px' }}>
  //         <Link
  //           external={true}
  //           url={getTranslation(
  //             'https://help.comgate.cz/docs/shopify#jak-povolit-platebn%C3%ADmu-dopl%C5%88ku-comgate-p%C5%99%C3%ADstup-k-informac%C3%ADm-o-n%C3%A1zvech-objedn%C3%A1vek-v-syst%C3%A9mu-shopify',
  //             'https://help.comgate.cz/docs/en/shopify#how-to-allow-comgate-to-access-order-name-information-in-shopify',
  //           )} >{getTranslation(
  //           'Pro povolení synchronizace postupujte podle návodu v helpu.',
  //           'To enable synchronization, follow the instructions in the help guide.',
  //         )}</Link>
  //       </p>
  //     </Card.Section>
  //   );
  // }

  return (
    <Card.Section>
      <TextContainer>
        <p>{getTranslation(
        'Synchronizace ID objednávky',
        'Order ID synchronization',
        )}</p>
        <p style={{ color: '#aa1437', marginTop: '6px' }}>{getTranslation(
        'Služba byla ukončena a bude přesunuta do klientského portálu Comgate. Pro její opětovnou aktivaci je nezbytné provést dodatečné kroky.',
        'The service has been discontinued and will be moved to the Comgate client portal. Additional steps will be required for its reactivation.',
        )}</p>
        <p style={{ color: '#6d7175', marginTop: '6px' }}>{getTranslation(
        'Důvodem ukončení služby byly požadavky společnosti Shopify, které omezují platební aplikace v rozsahu autorizací na Admin API obchodů.',
        'The service was discontinued due to Shopify’s requirements, which restrict payment applications in their authorised scope of access to the Store Admin API.',
        )}</p>
      </TextContainer>

      <Link
        external={true}
        url={getTranslation(
        'https://help.comgate.cz/docs/shopify#form%C3%A1t-%C4%8D%C3%ADsla-objedn%C3%A1vky-ze-shopify',
        'https://help.comgate.cz/docs/en/shopify#the-format-of-a-shopify-order',
      )} >{getTranslation(
        'Postup pro aktivaci nové služby naleznete v dokumentaci.',
        'You can find the procedure for activating the new service in the documentation.',
      )}</Link>
    </Card.Section>
  )
}
